<!--=========================== NEW LOGIN ======================= -->

<div class="lang_div">
  <select class="lang_select" (change)="switchLang($event)">
    @for (lang of languages; track lang) {
      <option [value]="lang" [selected]="lang === selectedLang">
        {{ lang }}
      </option>
    }
  </select>
</div>
<div class="login__container">
  <div class="login_panel">
    <span class="logo">
      <img src="../../../../assets/images/App-Logo.svg" alt="App Logo" />
    </span>

    <div class="form_header">{{ "login.welcome" | translate }}</div>
    <div class="form_sub_header">{{ "login.signin" | translate }}</div>
    @if (!isProduction) {
      <div class="login_form">
        <form [formGroup]="signInForm">
          <div class="form-row">
            <div class="form-group col-md-12">
              <div class="form-group">
                <span class="has-float-label">
                  <input
                    class="form-control"
                    id="username"
                    type="text"
                    placeholder=" "
                    formControlName="username"
                  />
                  <label for="username">{{ "login.Email" | translate }}</label>
                </span>
                @if (
                  signInForm.get("username")?.errors &&
                  (signInForm.get("username")?.dirty ||
                    signInForm.get("username")?.touched)
                ) {
                  <span
                    class="validation-message"
                    [hidden]="signInForm.get('username')?.hasError('required')"
                  >
                    {{ validationMessage.username.required }}
                    <br />
                  </span>
                }
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-12">
              <div class="form-group">
                <span class="has-float-label">
                  <input
                    class="form-control"
                    id="password"
                    type="password"
                    placeholder=" "
                    formControlName="password"
                    maxlength="8"
                  />
                  <label for="password">{{
                    "login.Password" | translate
                  }}</label>
                </span>
                @if (
                  signInForm.get("password")?.errors &&
                  (signInForm.get("password")?.dirty ||
                    signInForm.get("password")?.touched)
                ) {
                  @if (signInForm.get("password")?.hasError("invalid")) {
                    <div class="validation-message">
                      {{ validationMessage.password.invalid }}
                    </div>
                  } @else {
                    {{ validationMessage.password.invalid }}
                    <br />
                  }
                }
              </div>
            </div>
          </div>

          <div class="form_actions">
            @if (!isLogin) {
              <button
                class="form_button"
                [disabled]="!signInForm.valid"
                (click)="loginWithEmail(signInForm.value)"
              >
                <img
                  src="../../../../assets/icons/icon-log-out.svg"
                  alt="Login"
                />
                <span>{{ "login.Login" | translate }}</span>
              </button>
            } @else {
              <button class="form_button">
                <span>{{ "login.Loading" | translate }}...</span>
              </button>
            }
          </div>
        </form>
      </div>
      <div class="forgot_password-div">
        <a [routerLink]="['../recover-password']">{{
          "login.ForgotPassword" | translate
        }}</a>
      </div>
      <hr class="hor_rule" />
      <div class="or">{{ "Or" | translate }}</div>
    }
    @if (!isLoading$) {
      <button class="form_button" (click)="login()">
        <img
          src="../../../../assets/icons/icon-log-out.svg"
          alt="Login With Outlook"
        />
        <span>{{ "login.LoginWithOutlook" | translate }}</span>
      </button>
    } @else {
      <button class="form_button">
        <span>{{ "login.Loading" | translate }}...</span>
      </button>
    }
  </div>
</div>
